import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class IndexDetailsUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult() {
        return await this.repo.getIndexDetails();
    }
}
export default IndexDetailsUseCase;
